module.exports = __webpack_public_path__ + "static/media/redacao.03ae3827.svg";